// extracted by mini-css-extract-plugin
export default {"heroLogo":"HeroLogo_heroLogo__bLLrg"};